export default __webpack_public_path__ + "assets/delete_big.png";